import React from 'react';

const StatusBar = ({ mode, isCrossAreaSelecting, isMirrorMode }) => {
  const getMessage = () => {
    // Cross area selection mode
    if (isCrossAreaSelecting) {
      return "Click and drag to select area for cross area";
    }
    
    // Mirror mode
    if (isMirrorMode && mode === 'mirror') {
      return "Click to set first point of mirror line, then click second point";
    }
    
    // Shape creation modes
    switch (mode) {
      case 'rectangle':
        return "Click to set first corner, then click to set opposite corner";
      case 'square':
        return "Click to set first corner, then click to set opposite corner";
      case 'circle':
        return "Click to set center, then click to set a point on the radius";
      case 'ellipse':
        return "Click to set first control point, then click second, then click third point";
      case 'spline':
        return "Click to add control points, right-click to finish";
      case 'polyspline':
        return "Left-click to add interpolative points, right-click for straight lines";
      case 'poly':
        return "Click to add points, right-click to finish";
      case 'curve':
        return "Click to add control points, right-click to finish";
      case 'crossarea':
        return "Click to place the cross area";
      case 'select':
        return "Click to select objects, drag to move, Shift+click for multi-select";
      default:
        return "Ready";
    }
  };

  return (
    <div style={styles.statusBar}>
      <span style={styles.message}>{getMessage()}</span>
    </div>
  );
};

const styles = {
  statusBar: {
    height: '28px',
    backgroundColor: '#f8f8f8',
    borderTop: '1px solid #ccc',
    display: 'flex',
    alignItems: 'center',
    padding: '0 12px',
    fontSize: '0.85rem',
    color: '#333',
    flexShrink: 0
  },
  message: {
    color: '#555'
  }
};

export default StatusBar;
